import { Component, HostBinding } from '@angular/core'
import { Router } from '@angular/router'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { ApplicationArea, ProductsClient } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'vetcor-pricing-landing',
   templateUrl: './vetcor-pricing-landing.component.html',
   styleUrls: ['./vetcor-pricing-landing.component.scss'],
   standalone: false,
})
export class VetcorPricingLandingComponent {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   public isPricingManagerCaptain = false
   public isPricingManagerAdmin = false

   constructor(private authMgr: AuthManager, private router: Router) {
      this.authMgr.getCurrentUser().subscribe((user) => {
         this.isPricingManagerCaptain = this.authMgr.canAccess(user, {
            application: ApplicationArea.PricingManager,
            roleName: ['PricingManagerCaptain'],
         })
		 
		 this.isPricingManagerAdmin = this.authMgr.canAccess(user, {
            application: ApplicationArea.PricingManager,
            roleName: ['PricingManagerAdmin'],
         })

         if (!this.isPricingManagerAdmin) {
            this.router.navigate(['vetcor-pricing', 'vetcor-pricing-manager'])
         }
      })
   }
}
